@import '@hevoio/hevo-ui-toolkit/styles/variables';
@import '@hevoio/hevo-ui-toolkit/styles/typography/typography-utils';

.optionBody {
  @include typography-level-to-styles(typography-config(), body-2);
  color: $text-default;
  box-sizing: border-box;
  margin-bottom: $spacer * 1.25;
}

.radioGroup {
  width: 50%;
}

.textArea {
  width: 53% !important;
}

.shimmerOption {
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-bottom: $spacer * 1.25;
}
